import { isBrowser } from '@backmarket/utils/env/isBrowser'

const SSR_TIMEOUT_FOR_OPTIONAL_ENDPOINT = 5000
/**
 * Most endpoints on the product page are "optional". If the call fails, we just don't display the associated
 * features (i.e.: reviews). We want to override the default 20s timeout on SSR to avoid huge latency spikes
 * that can come from any endpoint to impact the product page latency
 */
export const getOptionalEndpointTimeoutOptions = () => {
  if (isBrowser()) return {}

  return { timeout: SSR_TIMEOUT_FOR_OPTIONAL_ENDPOINT }
}
